import { DefaultOptions, QueryClient } from 'react-query';
import i18next from 'i18next';

import { ERORR_CODES } from './constants';

function queryErrorHandler(error?: any): void {
  if (error) {
    if (error?.response?.data?.code) {
      const code = error.response?.data?.code.toLowerCase();
      const errorCode = ERORR_CODES[code];
      // Handle actions for Error HERE
      console.log('Error: ', {
        title: i18next.t(errorCode.title),
        message: i18next.t(errorCode.message),
        closeText: i18next.t(errorCode.closeText),
      });
    }
  }
}

const queryConfig: DefaultOptions = {
  // HANDLING CONFIG QUERY HERE
  queries: {
    onError: queryErrorHandler,
    retry: false,
    // refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  },
  mutations: {
    onError: queryErrorHandler,
  },
};

const queryClient = new QueryClient({
  defaultOptions: queryConfig,
});

export default queryClient;
